import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'flow-email-sendouts-item',
  templateUrl: './email-sendouts-item.component.html',
  styleUrls: ['./email-sendouts-item.component.scss'],
})
export class EmailSendoutsItemComponent {
  @Input() control!: FormControl;
  @Input() canRemove = false;
  @Input() disabled = false;
  @Output() remove = new EventEmitter<void>();

  onRemove(): void {
    this.remove.emit();
  }
}
